import React from 'react';
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorHandled: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
            this.setState((prev) => ({ ...prev, errorHandled: true }));
        }
        throw error;
    }
    render() {
        if (this.state.hasError && !this.state.errorHandled) {
            return null;
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
